"use client"

import { useState } from "react"

import { listProductReviews, ProductReview } from "@lib/data/products"
import { Button } from "@modules/common/components/ui"

import ReviewCard from "./review-card"

type ReviewsListProps = {
  productId: string
  initialReviews: ProductReview[]
  count: number
}

// Client pagination over the server-rendered first page: "Load more" calls
// the listProductReviews server action with the current offset and appends.
const ReviewsList = ({ productId, initialReviews, count }: ReviewsListProps) => {
  const [reviews, setReviews] = useState<ProductReview[]>(initialReviews)
  const [loading, setLoading] = useState(false)

  const loadMore = async () => {
    setLoading(true)
    try {
      const data = await listProductReviews(productId, reviews.length)
      setReviews((prev) => {
        const seen = new Set(prev.map((r) => r.id))
        return [...prev, ...data.reviews.filter((r) => !seen.has(r.id))]
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex flex-col">
      <div className="flex flex-col">
        {reviews.map((review) => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </div>
      {reviews.length < count && (
        <Button
          variant="secondary"
          size="small"
          className="mt-6 self-start"
          isLoading={loading}
          onClick={loadMore}
        >
          Load more reviews
        </Button>
      )}
    </div>
  )
}

export default ReviewsList
